var BID_UPDATE_TYPE;
(function (BID_UPDATE_TYPE) {
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["WAITING"] = 0] = "WAITING";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["NEGOTIATE"] = 1] = "NEGOTIATE";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["ACCEPT"] = 2] = "ACCEPT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["EDIT"] = 3] = "EDIT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["REJECT"] = 4] = "REJECT";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["VERIFY"] = 5] = "VERIFY";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["EXPIRE"] = 6] = "EXPIRE";
    BID_UPDATE_TYPE[BID_UPDATE_TYPE["DECLINE"] = 7] = "DECLINE";
})(BID_UPDATE_TYPE || (BID_UPDATE_TYPE = {}));

export { BID_UPDATE_TYPE };
//# sourceMappingURL=bidUpdateType.js.map
